import moment from 'moment';
import { gwPost, gwGet } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import { handleGwData, setPostBody } from '../actionsFactory';
import { obj2Query } from './margin';

const SECOND_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const REGX = /(?:\.0*|(\.\d+?)0+)$/;

export const fetchRecommendProducts = async () => {
  let rs = [];
  try {
    rs = await gwGet(`${API_PATH.LENDING_GET_RECOMMENDS}?featuredNum=2`);
    rs = handleGwData(rs) || [];
    rs = rs.map(({
      lotSize, interestPerLot, issueStartTime, issueEndTime, startTime, endTime, ...rest
    }) => ({
      ...rest,
      lotSize: lotSize.replace(REGX, '$1'),
      interestPerLot: interestPerLot.replace(REGX, '$1'),
      endTime: moment(+endTime).format(SECOND_FORMAT),
      startTime: moment(+startTime).format(SECOND_FORMAT),
      _issueStartTime: issueStartTime,
      _issueEndTime: issueEndTime,
      issueStartTime: moment(+issueStartTime).format(SECOND_FORMAT),
      issueEndTime: moment(+issueEndTime).format(SECOND_FORMAT),
    }));
  } catch (err) {
    rs = [];
  }
  return rs;
};

export const fetchProducs = async params => {
  let data = {
    data: [],
    total: 0,
  };

  try {
    data = await gwGet(API_PATH.LENDING_GET_PROJECTS + obj2Query(params));
  } catch (err) {
    data = {
      data: [],
      total: 0,
    };
  }
  data.data = data.data.map(({
    lotSize, interestPerLot, issueStartTime, issueEndTime, startTime, endTime, ...rest
  }) => ({
    ...rest,
    lotSize: lotSize.replace(REGX, '$1'),
    interestPerLot: interestPerLot.replace(REGX, '$1'),
    endTime: moment(+endTime).format(SECOND_FORMAT),
    startTime: moment(+startTime).format(SECOND_FORMAT),
    issueEndTime: moment(+issueEndTime).format(SECOND_FORMAT),
    issueStartTime: moment(+issueStartTime).format(SECOND_FORMAT),
  }));
  return data;
};

export const fetchLendingAssets = async () => {
  let data = [];
  try {
    data = handleGwData(await gwGet(`${API_PATH.LENDING_GET_ASSETS}`));
  } catch (err) {
    // noop
  }
  return data;
};

export const purchase = async params => {
  let rs = false;
  let error = {};
  try {
    const { success, data, code } = await gwPost(API_PATH.LENDING_PURCHASE, setPostBody(params));
    rs = success === true;
    error = {
      ...data,
      code,
    };
  } catch (err) {
    error = {
      failedReason: err.message,
    };
  }
  return [rs, error];
};

export const getPositionSummary = async () => {
  let rs = {};
  try {
    rs = handleGwData(await gwGet(API_PATH.LENDING_POSITION_SUMMARY));
  } catch (err) {
    // noop
  }
  return rs || {};
};
const fetchPositionList = params => gwGet(`${API_PATH.LENDING_POSITION_LIST}${obj2Query(params)}`);
const fetchSubscribeList = params => gwGet(`${API_PATH.LENDING_PURCHASE_HISTORY}${obj2Query(params)}`);
const fetchRedemptList = params => gwGet(`${API_PATH.LENDING_REDENPTION_HISTORY}${obj2Query(params)}`);

const apiMap = {
  'Assets': fetchPositionList,
  'Subscription': fetchSubscribeList,
  'Redemption': fetchRedemptList,
};

export const fetchLendingDataSource = async (type, params) => {
  let result = {
    total: 0,
    data: [],
  };
  try {
    const { success, data = [], total } = await apiMap[type](params);
    if (!success) throw new Error();
    result = {
      data,
      total,
    };
  } catch (error) {
    // nothing
  }
  return result;
};

export const fetchUserLeftQuota = async projectId => {
  let quote = -1;
  try {
    quote = handleGwData(await gwGet(`${API_PATH.LENDING_LEFT_QUOTA}?projectId=${projectId}`));
  } catch (err) {
    // noop
  }
  return quote;
};

export default {};
